<template>
  <div class="content-box">
    <img :src="getPicLink('indexM_bg.jpg')" width="100%" alt="" class="bg_img">
    <div class="content" ref="sy">
      <div class="head_nav">
        <img :src="getPicLink('logo.png')" alt="" class="logo">
        <div class="nav-right" ref="navList">
          <div class="nav-btn-outer" @click.stop="navChange">
            <div class="nav-btn">
              <div class="nav-btn-inner"></div>
            </div>
          </div>
          <div v-if="navFlag" class="nav-list">
            <div class="nav" v-for="(item, index) in navs" :class="[`nav_${index}`,{'nav_focus': index === navFocusFlag}]"
                 @mouseenter.stop="navFocus(index)" @mouseleave.stop="navFocus(-1)" @click.stop="scrollDom(index)">
              {{item}}
            </div>
          </div>
        </div>
      </div>
      <div class="webTitle"></div>
      <div class="rightSides">
        <img src="~img/rightSides.png" alt="" class="bg">
        <img src="~img/gzhCode.jpg" alt="" class="erweima">
      </div>
      <div class="download">
        <div class="download_ercode"></div>
        <div class="downloadBtn" v-for="(item, index) in outLink.download"
             :class="[{'hoverDownload': hoverDownload === item}]"
             @mouseenter.stop="enterDownload(item)"
             @mouseleave.stop="enterDownload('')"
             @click.stop="clickBooking(item)"></div>
      </div>
<!--      <div class="booking">-->
<!--        <div class="bookBtn" v-for="(item, index) in bookings"-->
<!--             :class="[`Booking`, {'hoverBooking': hoverBooking === item}]"-->
<!--             @mouseenter.stop="enterBooking(item)"-->
<!--             @mouseleave.stop="enterBooking('')"-->
<!--             @click.stop="clickBooking(item)"></div>-->
<!--      </div>-->
      <div class="bookProgress">
        <div class="levels">
          <div v-for="(item, index) in bookProgress" :class="`level level${item.num}`">
            <!--            <img :src="getPic(item.pic,'png')" width="100%" alt="">-->
          </div>
        </div>
        <div class="progressLine">
          <div class="line-box">
            <div class="line line1">
              <div v-if="lineShow >= 1"  class="progress" :style="{'width': lineShow === 1 ? lineWidth : '100%'}"></div><img v-if="lineShow === 1"  :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap" ><img :src="getPic(lineShow > 1 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`50000Pkg`, 'png')" alt="" class="gift gift1"></div>
            <div class="line line2">
              <div v-if="lineShow >= 2" class="progress" :style="{'width': lineShow === 2 ? lineWidth : '100%'}"></div><img v-if="lineShow === 2" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap"><img :src="getPic(lineShow > 2 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`100000Pkg`, 'png')" alt="" class="gift gift2"></div>
            <div class="line line3">
              <div v-if="lineShow >= 3" class="progress" :style="{'width': lineShow === 3 ? lineWidth : '100%'}"></div><img v-if="lineShow === 3" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap"><img :src="getPic(lineShow > 3 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`500000Pkg`, 'png')" alt="" class="gift gift3"></div>
            <div class="line line4">
              <div v-if="lineShow >= 4" class="progress" :style="{'width': lineShow === 4 ? lineWidth : '100%'}"></div><img v-if="lineShow === 4" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
            <div class="progress-gap"><img :src="getPic(lineShow > 4 ? `progress_dotted` : `progress_dot`, 'png')" alt="" class="dot"><img :src="getPic(`1000000Pkg`, 'png')" alt="" class="gift gift4"></div>
            <div class="line line5">
              <div v-if="lineShow >= 5" class="progress" :style="{'width': lineShow === 5 ? lineWidth : '100%'}"></div><img v-if="lineShow === 5" :src="getPic(`bookProgress`, 'png')" alt="" class="bookProgressArrow">
            </div>
          </div>
        </div>
      </div>
      <div class="txjw" ref="nav1">
        <div class="fixed-inner">
          <div class="news">
            <div class="news-left">
              <homeSwiper
                  id="bannerSwiper3"
                  v-if="newsDataPic.length>0"
                  :type="3"
                  :banner-list="newsDataPic"
                  pagination-align="center"
                  query-selector="#bannerSwiper3"/>
            </div>
            <div class="news-right">
              <div class="news-right-head">
                <div class="news-right-head-inner">
                  <div class="news-right-head-item" v-for="(item, index) in newsHead"
                       :class="{'checked': index === newsIndex}" @click.stop="chooseNews(index)">
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="news-right-list">
                <div v-for="(item, index) in newsData[newsIndex]" class="news-right-list-item" @click.stop="openNews(item)">
                  <div class="cate">【{{ newsHead[item.noticeType] }}】</div>
                  <div class="cont">{{ item.noticeTitle }}</div>
                  <div class="date">{{ getDate(item.updateTime || item.createTime) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="nav2" class="xkz">
        <div class="fixed-inner">
          <div class="roles">
            <div class="roles-up">
              <template v-for="(role, index) in roleData">
                <div class="role">
                  <div v-show="index === selectRoleCateIndex" class="role-detail">
                    <div class="fixed-box">
                      <div class="label career">职业介绍:</div>
                      <div class="label hard">操作难度:</div>
                      <div class="label property">主要属性:</div>
                      <div class="label element">元素专精:</div>
                      <div class="label skill">技能:</div>
                      <img class="rloeIcon" :src="getPic(`${role.name}Icon`, 'png')" width="100%" alt="">
                    </div>
                    <transition name="fade" mode="out-in">
                      <div v-show="index === selectRoleCateIndex" class="role-content">
                        <div class="role-pic">
                          <img :class="`${role.name}`"  :src="getPicLink(`role_${role.picName}.png`)" width="100%" alt="">
                        </div>
                        <div class="role-cont">
                          <div class="name">
                            <img :src="getPic(`${role.name}Title`, 'png')" width="100%" alt="">
                          </div>
                          <div class="career">
                            <div class="words">{{ role.detail }}</div>
                          </div>
                          <div class="hard">
                            <div class="words">{{ role.hard }}</div>
                          </div>
                          <div class="property">
                            <div class="words">{{ role.property }}</div>
                          </div>
                          <div class="element">
                            <div class="words">{{ role.element }}</div>
                          </div>
                          <div class="skill">
                            <img :src="getPic(`${role.name}Skill`, 'png')" width="100%" alt="">
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </template>
            </div>
            <div class="roles-bottom">
              <div class="role-left" v-for="(role, index) in roleData" @click.stop="selectRoleCate(index)">
                <img v-show="index !== selectRoleCateIndex" class="imgPre" :src="getPic(role.name,'png')" width="100%"
                     alt="">
                <img v-show="index === selectRoleCateIndex" class="imgClick" :src="getPicClick(role.name)" width="100%"
                     alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="nav3" class="jhfg">
        <div class="fixed-inner">
          <div class="box4">
            <homeSwiper
                id="bannerSwiper4"
                v-if="box4Pic.length>0"
                :type="4"
                :banner-list="box4Pic"
                :pn-btn="true"
                pagination-align="center"
                query-selector="#bannerSwiper4"/>
          </div>
        </div>
      </div>
      <div class="box-bottom">
        <div v-for="(item, index) in bottomLink" :class="`url${index+1}`" @click.stop="openOthers(item)">
          {{item.name}}
        </div>
        <div class="beian0">
          <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank"></a>
        </div>
        <div class="beian">
          <img :src="getRolePic('beian','png')" alt="">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002007896" rel="noreferrer" target="_blank">川公网安备51019002007896号</a>
        </div>
      </div>
    </div>
    <div v-if="openToast>0" class="toastContent">
      <div v-if="openToast===1" class="bookToast">
        <div class="head">游戏预约</div>
        <div class="close" @click.stop="closeToast">×</div>
        <div class="cates">
          <div class="cate" :class="{'selected': choosedType === 1}" @click.stop="chooseType(1)">
            Android
          </div>
          <div class="cate" :class="{'selected': choosedType === 2}" @click.stop="chooseType(2)">
            ios
          </div>
        </div>
        <div class="input">
          <label for="input_mobile_number" @click.stop="inputFocus('input_mobile_number')">
            <input
                v-model="mobileNum"
                id="input_mobile_number"
                ref="input_mobile_number"
                type="tel"
                class="input_mobile_number"
                placeholder="请输入手机号码"
                autocomplete="off"
                @change="changeValue"
                @input="mobileMaxLength"
            />
          </label>
          <label for="verify_mobile_number" @click.stop="inputFocus('verify_mobile_number')">
            <input
                v-model="verifyNum"
                id="verify_mobile_number"
                ref="verify_mobile_number"
                type="text"
                class="verify_mobile_number"
                placeholder="请输入验证码"
                autocomplete="off"
                @input="maxLength"
            />
            <div class="getVerifyNum" @click.stop="getVerifyNum">{{ interval_seconds > 0 ? `${interval_seconds}S` : '获取验证码' }}</div>
          </label>

        </div>
        <div class="next_step" @click.stop="getBooking">立即预约</div>
        <!--        <div class="agreePolicy">-->
        <!--          <div class="select iconfont icon-duigou selected"></div>-->
        <!--          我已详细阅读并同意 <span @click.stop="openUserTerm">《用户协议》</span>-->
        <!--          和 <span @click.stop="openPrivacyTerm">《隐私政策》</span>-->
        <!--        </div>-->
      </div>
      <div v-if="openToast === 4" class="successToast">
        <div class="close" @click.stop="closeToast">×</div>
        <div class="successIcon iconfont" :class="{'icon-duigouxuanzhong' : iconfontClass, 'icon-cuochayuankuangtianchong': !iconfontClass}"></div>
        <div class="title">{{successText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import role from '@/json/role.json'

export default {
  name: 'Mhome',
  data() {
    return {
      navs: role.navs,
      navFocusFlag: -1,
      navFlag: false,
      newsHead: ['最新', '新闻', '公告', '活动'],
      newsIndex: -1,
      newsData: {},
      newsDataAll: [],
      newsDataLen: 0,
      newsDataPic:['news0','news1'],
      roleData: role.cate,
      selectRoleCateIndex: 3,
      selectRoleIndex: 0,
      roleIndex: 0,
      changeMsgToastFlag: null,
      bookings: role.bookings,
      link1: role.link1,
      link2: role.link2,
      outLink: role.outLink,
      bookProgress: role.bookProgress,
      bottomLink: role.bottomLink,
      mobileNum: '',
      verifyNum: '',
      openToast: 0,
      newsPic: role.newsPic,
      box4Pic: role.box4Pic,
      inputBarrage: '',
      gzhShowFlag: false,
      choosedType: 1,
      sent: false,
      hoverBooking: '',
      hoverDownload: '',
      lineWidth: '0',
      lineShow: 0,
      interval_seconds: -1,
      intervalObj: null,
      successText:'',
      iconfontClass: true,
      autoChangeObj: null
    }
  },
  created() {
    this.getLineWidth();
  },
  mounted() {
    this.getNews();
    this.getNewsPic();
    this.autoChangeRole();
  },
  watch: {
    newsDataLen(n) {
      if (n === 3) {
        let data = [];
        for (let j = 0, len = this.newsDataAll.length; j < len; j++) {
          data.push({
            ...this.newsDataAll[j],
            time: this.getDateTime(this.newsDataAll[j].updateTime || this.newsDataAll[j].createTime)
          });
        }
        data.sort((a, b) => a.time - b.time);
        this.$set(this.newsData, 0, data.slice(0, 4));
        this.newsIndex = 0;
      }
    }
  },
  methods: {
    navFocus(index) {
      this.navFocusFlag = index;
    },
    navChange() {
      this.navFlag = !this.navFlag;
    },
    clickBooking(item) {
      window.open(item, '_blank');
    },
    enterBooking(type) {
      this.hoverBooking = type;
    },
    enterDownload(type) {
      this.hoverDownload = type;
    },
    chooseNews(index) {
      this.newsIndex = index;
    },
    openNews(item){
      this.$router.push({
        name: 'news',
        params: {news: item, type: 'mobile'}
      }).catch(() => {});
    },
    getDate(foo) {
      const date1 = foo.split(` `)[0], date2 = date1.split('-');
      return date2[1] + '-' + date2[2];
    },
    getRolePic(pic) {
      return require(`role/${pic}.png`);
    },
    getPic(pic, type) {
      return require(`imgM/${pic}.${type}`);
    },
    getPicClick(pic) {
      return require(`imgM/${pic}Click.png`);
    },
    getPicLink(name) {
      return this.outLink.picUrl + name;
    },
    //切换角色
    selectRoleCate(index) {
      clearInterval(this.autoChangeObj);
      this.selectRoleCateIndex = index;
      this.autoChangeRole();
    },
    autoChangeRole() {
      clearInterval(this.autoChangeObj);
      this.autoChangeObj = setInterval(()=>{
        if (this.selectRoleCateIndex < 3) {
          this.selectRoleCateIndex++;
        } else {
          this.selectRoleCateIndex = 0;
        }
      }, 4000)
    },
    changeRole(gap) {
      const len = this.roleData[this.selectRoleCateIndex].list.length;
      if (gap > 0 && this.selectRoleIndex < len - 1 || gap < 0 && this.selectRoleIndex > 0) {
        this.selectRoleIndex += gap;
      }
    },
    inputFocus(name) {
      if (this.$refs[name]) {
        this.$refs[name].focus();
      }
    },
    //底部跳转链接
    openOthers(item) {
      if (item.pic && item.pic === 'gzh') {
        this.gzhShowFlag = true;
      } else {
        //window.open(item.link, '_blank');
        this.$router.push({
          name: item.router
        }).catch(() => {});
      }
    },
    //官网预约
    maxLength() {
      if (this.verifyNum.length > 6) {
        this.verifyNum = this.verifyNum.slice(0, 6);
      }
    },
    changeValue(event) {
      this.mobileNum = event.target.value;
    },
    mobileMaxLength() {
      if (this.mobileNum.length > 11) {
        this.mobileNum = this.mobileNum.slice(0, 11);
      }
    },
    openUserTerm() {
      window.open(this.outLink.userTerm, '_blank');
    },
    openPrivacyTerm() {
      window.open(this.outLink.privacyTerm, '_blank');
    },
    bookingSuccessToast(txt, flag) {
      this.successText = txt;
      this.iconfontClass = flag
      this.openToast = 4;
      setTimeout(()=>{
        this.closeToast();
      }, 2000);
    },
    closeToast() {
      this.sent = false;
      this.choosedType = 1;
      this.openToast = 0;
    },
    scrollDom(ref) {
      if (ref === 4) {
        window.open('https://fanyukaitian.com.cn', '_blank');
        return;
      }
      this.$refs[`nav${ref}`].scrollIntoView();
    },
    getNews() {
      for (let i = 1; i < 4; i++) {
        api.sendGetRequest('newsList', {noticeType: i}, (isSuccess, data, err) => {
          if (isSuccess) {
            if (data.code === 200) {
              this.newsData[i] = data.rows;
              this.newsDataAll = this.newsDataAll.concat(data.rows);
              this.newsDataLen++;
            }
          } else {
            console.log(err.errorMsg);
          }
        });
      }
    },
    getNewsPic() {
      api.sendGetRequest('getNewsPic0', {}, (isSuccess, data, err) => {
        if (isSuccess) {
          this.newsDataPic = data;
        } else {
          console.log(err.errorMsg);
        }
      });
    },
    getDateTime(date) {
      const foo = new Date(date);
      return foo.getTime();
    },
    compareTime(item1, item2) {
      if (!item2) {
        return item1;
      }
      const time1 = this.getDateTime(item1.updateTime || item1.createTime);
      const time2 = this.getDateTime(item2.updateTime || item2.createTime);
      return item1 > time2 ? item1 : item2;
    },
    getVerifyNum() {
      if (this.interval_seconds > 0) {
        return;
      }
      this.sent = true;
      const params = {
        phone: this.mobileNum,
        type: this.choosedType
      }, that = this;
      api.sendRequest('sendCode', params, (isSuccess, data, err) => {
        if (isSuccess) {
          console.log(isSuccess, data, err);
          if (data.code === 0) {
            that.interval_seconds = 60;
            that.intervalObj = setInterval( ()=>{
              if ( that.interval_seconds > 0 ) {
                that.interval_seconds--;
              } else {
                clearInterval( that.intervalObj );
              }
            }, 1000 );
          } else {
            this.bookingSuccessToast(data.msg, false);
          }
        } else {
          console.log(err.errorMsg);
        }
      });
    },
    getBooking() {
      const params = {
        phone: this.mobileNum,
        code: this.verifyNum,
        type: this.choosedType
      };
      api.sendRequest('booking', params, (isSuccess, data, err) => {
        if (isSuccess) {
          if (data.code === 0) {
            this.bookingSuccessToast('您已成功预约游戏！', true);
          } else {
            this.bookingSuccessToast(data.msg, false);
          }
        } else {
          console.log(err.errorMsg);
        }
      });
    },
    chooseType(type) {
      this.choosedType = type;
    },
    getLineWidth() {
      const nowDate = new Date(),
          startDate= new Date("2025-04-01 00:00:00"),
          date5 = new Date("2025-04-07 00:00:00"),
          date10 = new Date("2025-04-14 00:00:00"),
          date50 = new Date("2025-04-21 00:00:00"),
          date100 = new Date("2025-05-06 00:00:00");
      let lineWidth = 0;
      if (nowDate > date100) {
        this.lineShow = 5;
        lineWidth = 0;
      } else if (nowDate > date50) {
        this.lineShow = 4;
        lineWidth =  2.06*(nowDate - date50)/(date100 - date50);
      } else if (nowDate > date10) {
        this.lineShow = 3;
        lineWidth = 1.53*(nowDate - date10)/(date50 - date10);
      } else if (nowDate > date5) {
        this.lineShow = 2;
        lineWidth = 1.26*(nowDate - date5)/(date10 - date5);
      } else {
        this.lineShow = 1;
        lineWidth = 0.58*(nowDate - startDate)/(date5 - startDate);
      }
      this.lineWidth = lineWidth.toFixed(3)+'rem';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "~styles/index.less";

.content-box {
  position: relative;
  width: 7.5rem;
  background: RGBA(8, 17, 30, 1);
  height: 60.9rem;

  .bg_img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .head_nav {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: .85rem;
      z-index: 1000;

      .logo{
        float: left;
        margin: -.16rem 0 0 -.04rem;
        width: 1.79rem;
        height: auto;
      }

      .nav-right{
        position: absolute;
        right: 0;
        top: 0;
        width: 1.97rem;
        height: .82rem;

        .nav-btn-outer {
          box-sizing: border-box;
          width: 1.97rem;
          height: .82rem;
          text-align: right;
          padding-top: .28rem;

          .nav-btn {
            margin-right: .79rem;
            display: inline-block;
            width: .38rem;
            height: .3rem;
            border-top: .03rem solid #E0EFFF;
            border-bottom: .03rem solid #E0EFFF;

            .nav-btn-inner {
              width: 100%;
              height: .14rem;
              border-bottom: .03rem solid #E0EFFF;
            }
          }
        }

        .nav-list {
          box-sizing: border-box;
          padding-top: .06rem;
          width: 1.97rem;
          height: 2.74rem;
          background: rgba(7, 26, 47, .74);

          .nav {
            width: 100%;
            height: .54rem;
            cursor: pointer;
            font-family: STZhongsong;
            font-weight: 400;
            font-size: 0.3rem;
            color: rgba(182, 208, 235, 1);
            line-height: 0.55rem;

            &.nav_focus::before {
              color: rgba(199, 169, 87, 1);
            }
          }
        }
      }
    }

    .webTitle {
      position: absolute;
      top: 7.2rem;
      left: 0.26rem;
      width: 6.9rem;
      height: 4rem;
      .background('https://scszsj-system.oss-cn-beijing.aliyuncs.com/pic0/bannerLogoM.png');
    }

    .rightSides{
      position: fixed;
      right: 0;
      top: 5.5rem;
      width: 1.64rem;
      z-index: 100;
      img{
        width: 100%;
      }
      .erweima{
        position: absolute;
        width: 1rem;
        height: auto;
        left: .52rem;
        top: .78rem;
        z-index: 2;
      }
    }

    .download {
      margin-top: 11.26rem;
      margin-left: 1.8rem;
      padding-top: .1rem;
      width: 4rem;
      height: 1.66rem;
      .background('~role/downloadBtn.png');

      .download_ercode{
        float: left;
        margin-top: 0;
        margin-left: .15rem;
        width: 1.48rem;
        height: 1.48rem;
        .background('~role/downloadERC.png');
      }

      .downloadBtn {
        margin-left: 2.2rem;
        width: 1.6rem;
        height: 0.5rem;
        cursor: pointer;
      }
    }

    .booking {
      margin-top: 11.62rem;
      margin-left: 2.05rem;
      width: 3.37rem;
      height: .96rem;

      .bookBtn {
        width: 3.37rem;
        height: .96rem;
        cursor: pointer;


        &.Booking {
          .background('~imgM/Booking.png');

          &.hoverBooking {
            .background('~imgM/BookingHover.png');
          }
        }
      }
    }

    .fixed-inner{
      margin-top:  .82rem;
      width: 100%;
      position: relative;
    }

    .bookProgress {
      .clr();
      top: 13rem;
      width: 100%;
      height: 15.29rem;

      .levels {
        width: 100%;
        height: 13.25rem;

        .level {
          position: absolute;
          width: 2.63rem;
          height: auto;

          .num {
            width: 100%;
            height: .5rem;
            line-height: .5rem;
            font-family: FZBaoHeiTiS;
            font-weight: 800;
            font-size: .48rem;
            color: #CCA711;
          }

          img {
            width: 100%;
            height: 3.7rem;
          }

          &.level20 {
            left: 1.7rem;
            top: .36rem;
          }

          &.level60 {
            left: 5.6rem;
            top: 1.46rem;
          }

          &.level100 {
            left: 9.7rem;
            top: .4rem;
          }
        }
      }

      .progressLine {
        position: relative;
        width: 100%;
        height: 2.04rem;

        .line-box {
          position: absolute;
          left: .26rem;
          top: .8rem;
          width: 6.98rem;
          height: .1rem;
          display: flex;
          align-items: center;

          .line {
            position: relative;
            height: .03rem;
            background: #D9CD9F;
            display: flex;
            align-items: center;
            justify-content: left;
            .progress{
              width: 50%;
              height: .03rem;
              background: #E4C161;
            }
            .bookProgressArrow{
              margin-left: -0.06rem;
              width: 0.2rem;
              height: auto;
            }

            &.line1, &.line5{
              width: .58rem;
            }
            &.line2{
              width: 1.26rem;
            }
            &.line3{
              width: 1.53rem;
            }
            &.line4{
              width: 2.06rem;
            }
          }

          .progress-gap{
            position: relative;
            width: 0.13rem;
            height: 0.13rem;
            margin: 0 .06rem;
            .dot{
              margin-left: -.02rem;
              display: inline-block;
              width: 0.18rem;
              height: 0.13rem;
            }
            .gift{
              position: absolute;
              bottom: -.6rem;

              &.gift1{
                width: 1.2rem;
                left: -.4rem;
              }
              &.gift2{
                width: 1.33rem;
                left: -.45rem;
              }
              &.gift3{
                width: 1.28rem;
                left: -.45rem;
              }
              &.gift4{
                width: 1.42rem;
                left: -.58rem;
              }
            }
          }
        }
      }
    }

    .txjw {
      position: absolute;
      top: 28.62rem;
      width: 100%;
      height: 11.12rem;

      .news {
        .clr();
        top: 1.12rem;
        width: 7rem;
        height: auto;

        .news-left {
          width: 7rem;
          height: 3.64rem;
          padding: .05rem 0 0 .06rem;
        }

        .news-right {
          margin: 1.07rem 0 0 .42rem;
          width: 6.11rem;
          height: 3.6rem;

          .news-right-head {
            width: 100%;
            height: .63rem;
            padding-top: .1rem;

            .news-right-head-inner {
              display: flex;
              width: 3rem;
              justify-content: space-between;

              .news-right-head-item {
                position: relative;
                margin: .02rem 0 0;
                width: auto;
                height: .6rem;
                text-align: center;
                font-family: STZhongsong;
                font-weight: 400;
                font-size: 0.23rem;
                color: #FFFFFF;
                line-height: 0.6rem;
                cursor: pointer;
              }

              .news-right-head-item.checked {
                color: rgba(199, 169, 87, 1);
              }
            }
          }

          .news-right-list {
            .clr();
            width: 6.3rem;
            height: 2rem;
            overflow-y: scroll;

            .news-right-list-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: .56rem;
              cursor: pointer;

              .cate {
                width: .72rem;
                font-family: Source Han Serif CN;
                font-weight: 500;
                font-size: 0.17rem;
                color: rgba(109, 115, 121, 1);
                white-space: nowrap;
              }

              .cont {
                width: 4.4rem;
                font-weight: 500;
                font-size: 0.17rem;
                font-family: Source Han Serif CN;
                color: rgba(109, 115, 121, 1);
                text-align: left;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }

              .date {
                width: 1rem;
                font-weight: 500;
                font-family: Source Han Serif CN;
                font-size: 0.17rem;
                color: rgba(109, 115, 121, 1);
              }
            }
          }
        }
      }
    }

    .xkz {
      position: absolute;
      top: 39.7rem;
      width: 100%;
      height: 10.8rem;
      overflow: hidden;
      font-family: STZhongsong;

      .roles {
        padding-top: .3rem;
        width: 100%;
        height: 6rem;

        .roles-up {
          position: relative;
          width: 100%;

          .role {
            width: 7.5rem;

            .role-detail {
              width: 7.5rem;
              height: 5.4rem;

              .fixed-box {
                position: absolute;
                right: .23rem;
                top: .81rem;
                width: 3rem;
                height: 100%;
                z-index: 2;

                .label {
                  margin-right: .2rem;
                  width: 3rem;
                  height: .32rem;
                  line-height: .32rem;
                  text-align: left;
                  font-family: STZhongsong;
                  font-size: .24rem;
                  color: #C7A957;

                  &.career{
                    margin-top: 1.5rem;
                  }
                  &.hard{
                    margin-top: 2rem;
                  }
                  &.property{
                    margin-top: .12rem;
                  }
                  &.element{
                    margin-top: .12rem;
                  }
                  &.skill{
                    margin-top: .4rem;
                  }
                }
                .rloeIcon{
                  position: absolute;
                  right: -.1rem;
                  top: -1.4rem;
                  width: 2.2rem;
                }
              }

              .fade-enter-active {
                transition: all 1.5s;
              }

              .fade-leave-active {
                transition: all 0s;
              }

              .fade-leave, .fade-leave-to {
                opacity: 0;
              }

              .fade-enter, .fade-enter-from {
                opacity: 1;
                transform: translateX(2rem);
              }


              .role-pic {
                width: auto;
                height: 9.7rem;
                overflow: hidden;

                img {
                  width: 10rem;
                  position: absolute;
                  left: -2.2rem;
                  top: -.4rem;
                }

                .yingren{
                  left: -1.4rem;
                }
                .jianshi{
                  left: -3.2rem;
                  top: -1.8rem;
                }
                .youxia{
                  width: 13rem;
                  left: -2.26rem;
                  top: -2.3rem;
                }
              }

              .role-cont {
                position: absolute;
                right: .23rem;
                top: 0;
                width: 3rem;
                height: 100%;
                text-align: left;
                z-index: 3;

                .words {
                  font-family: STZhongsong;
                  font-size: .2rem;
                  color: #fff;
                  line-height: .32rem;
                }

                .name {
                  margin-top: .8rem;
                  width: 1.77rem;
                  height: .91rem;
                  overflow: hidden;
                  img {
                    width: 1.77rem;
                  }
                }

                .career {
                  margin-top: .68rem;
                  .words {
                    padding-top: .3rem;
                    width: 2.8rem;
                    height: 1.4rem;
                  }
                }

                .hard,.property,.element {
                  .words{
                    padding-left: 1.2rem;
                  }
                }
                .hard{
                  margin-top: .54rem;
                }
                .property {
                  margin-top: .12rem;
                }
                .element {
                  margin-top: .12rem;
                }
                .skill {
                  margin-top: .7rem;
                  margin-left: -.24rem;
                  img{
                    width: 104%;
                  }
                }
              }
            }
          }
        }

        .roles-bottom {
          margin-top: 2.7rem;
          width: 100%;
          box-sizing: border-box;
          padding: 0 .8rem;
          height: 1.22rem;
          display: flex;

          .role-left {
            position: relative;
            width: 1.12rem;
            height: 1.12rem;
            flex: 1;

            .imgPre {
              width: 1.12rem;
              height: 1.12rem;
              cursor: pointer;
            }

            .imgClick {
              width: 1.12rem;
              height: 1.12rem;
              cursor: pointer;
            }
          }
        }
      }
    }

    .jhfg {
      position: absolute;
      top: 50rem;
      width: 100%;

      .box4 {
        .wh(708, 397);
        .clr();
        top: 1.67rem;
        padding: .06rem 0 0 .09rem;
        //.background('~imgM/box4bg.png');
      }
    }

    .box6 {
      position: absolute;
      left: .27rem;
      bottom: 2.98rem;
      display: flex;

      .box6-bg {
        position: absolute;
        top: -1.5rem;
        width: 100%;
        text-align: center;
        font-family: Source Han Serif CN;
        font-weight: 500;
        font-size: .2rem;
        color: #7C6532;
        line-height: .3rem;
      }

      .left-box {
        margin-right: 1.36rem;
        display: flex;
      }

      .right-box {
        display: flex;
      }

      .item {
        width: .85rem;
        height: 1.07rem;
        margin-right: .11rem;
        cursor: pointer;

        .pic {
          width: 100%;
          height: .8rem;
          margin-bottom: .06rem;
        }

        .name {
          width: 100%;
          height: .3rem;
          line-height: .3rem;
          font-family: Source Han Serif CN;
          font-weight: 500;
          font-size: .22rem;
          color: #7C6532;
        }

        .gzhPic {
          position: absolute;
          top: -2rem;
          left: -.3rem;
          width: 2rem;
          height: 2rem;
        }
      }
    }

    .box-bottom{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      .url1{
        position: absolute;
        bottom: 2.26rem;
        left: .4rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: #D9C9A0;
      }
      .url2{
        position: absolute;
        bottom: 2.26rem;
        left: 1.7rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: #D9C9A0;
      }
      .beian0{
        position: absolute;
        bottom: 1rem;
        left: .4rem;
        width: 4rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        a{
          display: inline-block;
          margin-left: .1rem;
          width: 100%;
          height: 100%;
        }
      }
      .beian{
        position: absolute;
        bottom: .04rem;
        left: .4rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        img{
          height: 100%;
          margin-left: .1rem;
        }
        a{
          display: inline-block;
          margin-left: .1rem;
          width: auto;
          font-family: FZYaSongS-B-GB;
          font-weight: 400;
          font-size: 0.2rem;
          color: #4D4D4D;
        }
      }
    }
  }

  .toastContent {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 2;
    background: rgba(25, 25, 25, .6);

    .bookToast {
      position: absolute;
      top: 4.24rem;
      left: 0.69rem;
      width: 6.14rem;
      height: 4.89rem;
      background: #EFF2F5;

      .head {
        margin: .35rem 0 .42rem;
        width: 100%;
        height: .55rem;
        font-family: STZhongsong;
        font-weight: 400;
        font-size: 0.55rem;
        color: #585858;
        line-height: .45rem;
        text-align: center;
      }

      .close {
        position: absolute;
        right: .16rem;
        top: .15rem;
        width: .21rem;
        height: .16rem;
        line-height: .16rem;
        color: #585858;
        font-size: .3rem;
        text-align: center;
        font-weight: bold;
        cursor: pointer;
      }

      .cates {
        width: 100%;
        height: .6rem;
        line-height: .6rem;
        display: flex;
        align-items: center;

        .cate {
          flex: 1;
          width: auto;
          height: .74rem;
          line-height: .74rem;
          cursor: pointer;
          font-size: .37rem;
          font-weight: 400;
          color: #646464;;
          background: #DADFE3;

          &.selected {
            color: #F1C333;
            background: #FFFFFF;
          }
        }
      }

      .input {
        margin-top: .45rem;
        padding-left: .44rem;
        width: 5.26rem;
        height: auto;

        label {
          display: flex;
          position: relative;
          width: 5.26rem;
          height: .44rem;
          margin-bottom: .22rem;
          align-items: center;

          input {
            box-sizing: border-box;
            width: 100%;
            height: .44rem;
            line-height: .44rem;
            border: .01rem solid #C9C9C9;
            background: transparent;
            font-family: STZhongsong;
            font-weight: 400;
            font-size: 0.22rem;
            color: #8C8E99;
            outline: none;
            text-align: center;

            &.verify_mobile_number{
              width: 3.5rem;
            }
          }

          .getVerifyNum {
            width: 1.6rem;
            height: .44rem;
            margin-left: .21rem;
            line-height: .44rem;
            font-family: Source Han Serif CN;
            font-weight: 500;
            font-size: .22rem;
            color: #585858;
            background: #F9F9F9;
            outline: .01rem solid #F0F0F0;
            outline-offset: -.04rem;
            cursor: pointer;

            &.sent {
              color: #818181;
            }
          }
        }

      }

      .next_step {
        margin-left: 2.08rem;
        margin-top: .35rem;
        width: 1.97rem;
        height: 0.48rem;
        background: linear-gradient(0deg, #F9CC3F 0%, #EFB310 99%);
        border-radius: 0.09rem;
        font-family: STZhongsong;
        font-weight: 400;
        font-size: 0.3rem;
        color: #352908;
        line-height: 0.48rem;
        text-align: center;
        cursor: pointer;
      }

      .agreePolicy {
        margin: .27rem 0 0 .3rem;
        width: 3.62rem;
        height: .3rem;
        font-family: Source Han Serif CN;
        font-weight: 500;
        font-size: .14rem;
        color: #818181;
        line-height: .3rem;
        display: flex;
        align-items: center;

        .select {
          margin-right: .1rem;
          width: .12rem;
          height: .12rem;
          border: .01rem solid #A9A9A9;

          &.selected {
            line-height: .14rem;;
            border-color: transparent;
            font-size: .14rem;
            color: rgba(245, 186, 59, 1);
          }
        }

        span {
          color: rgba(101, 152, 244, 1);
          font-size: .14rem;
          cursor: pointer;
        }
      }
    }

    .successToast{
      position: absolute;
      top: 3.5rem;
      left: 1.4rem;
      box-sizing: border-box;
      padding: .4rem;
      width: 5rem;
      min-height: 3rem;
      background: #fefef5;
      border-radius: .12rem;

      .close {
        position: absolute;
        right: .3rem;
        top: .25rem;
        width: .2rem;
        height: .2rem;
        line-height: .2rem;
        color: rgba(131, 125, 110, 1);
        font-size: .36rem;
        text-align: center;
        font-weight: bold;
        cursor: pointer;
      }

      .successIcon{
        font-size: 1rem;
        color: #5fa964;
        text-align: center;
        margin: 0 0 .3rem;
      }

      .title{
        font-family: Source Han Serif CN;
        font-size: .4rem;
        line-height: .5rem;
        text-align: center;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/mhome.vue